import { Component,OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebapiService } from '../../../shared/services/webapi.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-contact-dropdown',
  templateUrl: './contact-dropdown.component.html',
  styleUrls: ['./contact-dropdown.component.scss']
})
export class ContactDropdownComponent {
  formSubmitting=false;

  contactForm: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])],
    name: ['', Validators.compose([Validators.required])],
    message: ['', Validators.compose([Validators.required])]
  });

  constructor(private fb: FormBuilder, public webApi: WebapiService, private toastrService: ToastrService, public router: Router) {
  }

  contact(event:any,form: FormGroup) {
    event.preventDefault()
    event.stopPropagation()
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      this.webApi.contactEmail(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
					this.toastrService.success(data.message);
          $('dropdown-menu.contact-menu').trigger('click');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.formSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.contactForm.controls;
  }

}
